import { useRef } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';
import type { Empresa } from '@/api/types';
import { EmpresaListRow } from './EmpresaListRow';

export function EmpresaListVirtual({ items }: { items: Empresa[] }) {
  const parentRef = useRef<HTMLDivElement>(null);
  const v = useVirtualizer({
    count: items.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 64,
    overscan: 8,
  });
  return (
    <div ref={parentRef} className="h-[calc(100vh-220px)] overflow-auto border rounded-md bg-card">
      <div style={{ height: `${v.getTotalSize()}px`, position: 'relative' }}>
        {v.getVirtualItems().map((vi) => {
          const e = items[vi.index];
          if (!e) return null;
          return (
            <div
              key={vi.key}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                transform: `translateY(${vi.start}px)`,
                height: `${vi.size}px`,
              }}
            >
              <EmpresaListRow e={e} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
